import React from "react";

const PrintContainer = props => {
  const containerStyle = {
    backgroundColor: "#fff",
    textAlign: "left",
    //padding: "30px",
    fontSize: "12px",
    margin: "0px",
    width: "210mm",
    height: "296mm",
    padding: "8mm"
  };

  return <div style={containerStyle}>{props.children}</div>;
};

export default PrintContainer;
